module.exports = __webpack_public_path__ + "media/images/font/SofiaPro-Bold-22ed2394a384bd908e662d85492ff55c.woff";